import React, { useState } from "react";

const FindPassword = () => {
  const [activeTab, setActiveTab] = useState(0);

  const homepageTabs = [
    { name: "아이디 찾기", current: activeTab === 0 },
    { name: "비밀번호 찾기", current: activeTab === 1 },
  ];

  const content =
    activeTab === 0 ? (
      <div className="mx-[3rem] my-14">
        <p className="font-bold text-title-black text-[15px]">아이디 찾기</p>
        <p className="mt-2 text-[14px] text-title-black">
          관리자 설정{">"}정보 수신 설정의 '관리자 연락처 관리'에
          <br />
          등록된 휴대전화 번호를 입력해주세요.
        </p>
        <input
          type="text"
          placeholder="휴대전화 번호 입력"
          className="py-2 placeholder:text-[#C7C7C7] px-4 w-full border mt-3"
        />
      </div>
    ) : (
      <div className="mx-[3rem] my-14">
        <p className="font-bold text-title-black text-[15px]">비밀번호 찾기</p>
        <p className="mt-2 text-[14px] text-title-black">
          관리자 설정{">"}정보 수신 설정의 '관리자 연락처 관리'에
          <br />
          등록된 휴대전화 번호를 입력해주세요.
        </p>
        <input
          type="text"
          placeholder="휴대전화 번호 입력"
          className="py-2 px-4 placeholder:text-[#C7C7C7] w-full border mt-3"
        />
      </div>
    );

  return (
    <div className=" flex-row justify-center max-w-[36rem] m-auto px-6 md:px-20 pt-44 h-screen overflow-hidden">
      <div className="border py-8 border-white bg-white">
        <div className="border rounded-full mx-[3rem] border-drop-yellow flex justify-between">
          {homepageTabs.map((tabs, index) => (
            <p
              aria-current={tabs.current ? "page" : undefined}
              onClick={() => setActiveTab(index)}
              key={tabs.name}
              className={`${
                tabs.current && "border-drop-yellow bg-drop-yellow font-bold"
              } cursor-pointer m-1 rounded-2xl text-primary-blue w-40 text-center py-2 text-sm`}
            >
              {tabs.name}
            </p>
          ))}
        </div>
        <div>{content}</div>
        <div className="mx-[3rem] mt-4 mb-8">
          <button className="bg-drop-yellow rounded-[4px] w-full py-3">
            찾기
          </button>
        </div>
      </div>
      <div className="text-primary-grey mt-24 text-[10px] text-center">
        Copyright(C) ONEDAYBIOTECH, All rights reserved.
      </div>
    </div>
  );
};

export default FindPassword;
